// ---------------------------------------------------------------------------
// Mapa de rotas INTERNAS -> item de menu (link-base, sem lang).
//
// O menu antigo aponta para a LISTAGEM de cada recurso. As telas internas (registro/edição/detalhe)
// têm caminho DIFERENTE (ex.: /category-registration não começa com /categories), então "prefixo"
// não as associa ao item. Este mapa faz essa ponte: ao abrir uma tela interna, o item da listagem
// correspondente fica ativo e seu grupo-pai abre.
//
// Chaves e valores em minúsculas, SEM o prefixo /:lang. O matcher (menuMatch.js) casa por segmento,
// então uma chave como '/called-accompaniment' cobre '/called-accompaniment/123' e
// '/called-accompaniment/deleted/5'. Só entram aqui rotas cujo alvo EXISTE como item do menu antigo.
//
// Mantido em arquivo próprio (e não espalhado no header-menu/index.js de 3718 linhas) para ser
// auditável num só lugar e não aumentar o risco naquele arquivo crítico.
// ---------------------------------------------------------------------------

// Links do menu que apontam para a MESMA tela sob nomes diferentes (alternados por flag).
export const MENU_LINK_EQUIVALENCE = {
  '/new-calleds': '/calleds',
};

export const MENU_ROUTE_ALIASES = {
  // Chamados
  '/called-registration': '/calleds',
  '/called-accompaniment': '/calleds',
  '/called-view': '/calleds',
  '/called-edit-organization': '/calleds',
  '/called-time-entries-registration': '/calleds',
  '/called-time-entries-edit': '/calleds',
  '/additional-called-cost-registration': '/calleds',
  '/additional-called-cost-edit': '/calleds',
  '/relationshipcalled-registration': '/calleds',
  '/called-view-archived': '/archived-calleds',
  '/called-rejection-edit': '/called-rejection',
  '/calledclassification-registration': '/calledclassifications',
  '/calledclassification-edit': '/calledclassifications',
  '/assignedcalled-registration': '/assignedcalleds',
  '/assignedcalled-edit': '/assignedcalleds',

  // Cadastros base
  '/category-registration': '/categories',
  '/category-edit': '/categories',
  '/sla-registration': '/slas',
  '/sla-edit': '/slas',
  '/type-registration': '/types',
  '/type-edit': '/types',
  '/segment-registration': '/segments',
  '/segment-edit': '/segments',
  '/reason-registration': '/reasons',
  '/reason-edit': '/reasons',
  '/group-registration': '/groups',
  '/group-edit': '/groups',
  '/status-registration': '/statuses',
  '/status-edit': '/statuses',
  '/priority-registration': '/priorities',
  '/priority-edit': '/priorities',
  '/material-registration': '/materials',
  '/material-edit': '/materials',
  '/unit-registration': '/units',
  '/unit-edit': '/units',
  '/holiday-registration': '/holidays',
  '/holiday-edit': '/holidays',
  '/workhour-registration': '/workhours',
  '/workhour-edit': '/workhours',
  '/workhour-edit-register': '/workhours',
  '/slacounttype-registration': '/slacounttypes',
  '/slacounttype-edit': '/slacounttypes',
  '/originrequest-registration': '/originrequests',
  '/originrequest-edit': '/originrequests',
  '/distributionstrategy-registration': '/distributionstrategies',
  '/distributionstrategy-edit': '/distributionstrategies',
  '/config-registration': '/configs',
  '/config-edit': '/configs',
  '/params-registration': '/params',
  '/params-edit': '/params',
  '/tags-edit': '/tags-list',
  '/default-actions-registration': '/default-actions',
  '/default-actions-edit': '/default-actions',
  '/task-template-registration': '/task-templates',
  '/task-template-edit': '/task-templates',
  '/email-template-registration': '/email-templates',
  '/email-template-edit': '/email-templates',
  '/status-email-notification-registration': '/status-email-notifications',
  '/status-email-notification-edit': '/status-email-notifications',
  '/activity-registration': '/activity-list',
  '/activity-edit': '/activity-list',
  '/alert-registration': '/alert-list',
  '/alert-edit': '/alert-list',
  '/nps-search-registration': '/nps-search',
  '/nps-search-edit': '/nps-search',
  '/satisfaction-survey-registration': '/satisfaction-survey-list',
  '/satisfaction-survey-edit': '/satisfaction-survey-list',
  '/called-closing-statuses-registration': '/called-closing-statuses',
  '/called-closing-statuses-edit': '/called-closing-statuses',

  // Patrimônio
  '/patrimonygroup-registration': '/patrimonygroups',
  '/patrimonygroup-edit': '/patrimonygroups',
  '/patrimonymaterial-registration': '/patrimonymaterials',
  '/patrimonymaterial-edit': '/patrimonymaterials',
  '/patrimonysubgroup-registration': '/patrimonysubgroups',
  '/patrimonysubgroup-edit': '/patrimonysubgroups',

  // Custos adicionais
  '/additionalcalledcostitem-registration': '/additional-service-config',
  '/additionalcalledcostitem-edit': '/additional-service-config',
  '/additionalcalledcostreason-registration': '/additional-service-config',
  '/additionalcalledcostreason-edit': '/additional-service-config',
  '/additionalcalledcosttype-registration': '/additional-service-config',
  '/additionalcalledcosttype-edit': '/additional-service-config',

  // Organizações
  '/organization-registration': '/organizations',
  '/organization-import': '/organizations',
  '/organization-edit': '/organizations',
  '/wizard-organization': '/organizations',
  '/organizationaccountemails': '/organizations',
  '/organizationaccountemail-registration': '/organizations',
  '/organizationaccountemail-edit': '/organizations',
  '/organizationcategory-registration': '/organizationcategories',
  '/organizationcategory-edit': '/organizationcategories',
  '/organizationsla-registration': '/organizationslas',
  '/organizationsla-edit': '/organizationslas',
  '/organizationdepartament-registration': '/organizationdepartaments',
  '/organizationdepartament-edit': '/organizationdepartaments',
  '/organizationmaterial-registration': '/organizationmaterials',
  '/organizationmaterial-edit': '/organizationmaterials',
  '/organizationpatrimony-registration': '/organizationpatrimonies',
  '/organizationpatrimony-edit': '/organizationpatrimonies',
  '/calledlistdata-registration': '/calledlistdatas',
  '/calledlistdata-edit': '/calledlistdatas',
  '/called-report-config-registration': '/called-report-configs',
  '/called-report-config-edit': '/called-report-configs',
  '/calledservicesettings-edit': '/calledservicesettings',

  // Acesso / usuários
  '/user-registration': '/users',
  '/user-import': '/users',
  '/user-edit': '/users',
  '/user-copy-profile': '/users',
  '/user-client-registration': '/users-client',
  '/user-client-edit': '/users-client',
  '/user-edit-client': '/users-client',
  '/role-registration': '/roles',
  '/role-edit': '/roles',
  '/permission-registration': '/permissions',
  '/permission-edit': '/permissions',

  // Grupos de atendimento
  '/techinicalteam-registration': '/techinicalteams',
  '/techinicalteam-edit': '/techinicalteams',
  '/techinicalteamuser-registration': '/techinicalteamusers',
  '/techinicalteamuser-edit': '/techinicalteamusers',
  '/techinicalteamorganizationcategory-registration': '/techinicalteamorganizationcategories',
  '/techinicalteamorganizationcategory-edit': '/techinicalteamorganizationcategories',
  '/techinicalteamorganization-registration': '/techinicalteamorganizations',
  '/techinicalteamorganization-edit': '/techinicalteamorganizations',

  // Integrações / automação
  '/authentication-registration': '/authentication',
  '/authentication-edit': '/authentication',
  '/integration-service-registration': '/integration-service',
  '/integration-service-edit': '/integration-service',
  '/variable-registration': '/variable',
  '/variable-edit': '/variable',
  '/webhook-registration': '/webhooks',
  '/webhook-edit': '/webhooks',
  '/automation': '/automationv2',
  '/automation-registration': '/automationv2',
  '/automation-edit': '/automationv2',
  '/macro-registration': '/macro-list',
  '/macro-edit': '/macro-list',
  '/kanban-board-edit': '/kanban',
  '/announcement-register': '/announcement',
  '/announcement-edit': '/announcement',

  // IA
  '/llm-registration': '/llms',
  '/llm-edit': '/llms',
  '/llm-events-registration': '/llm-events',
  '/llm-events-edit': '/llm-events',

  // 2Talk / Omnichannel
  '/channel-registration': '/channel',
  '/channel-edit': '/channel',
  '/customer-registration': '/customers',
  '/customer-edit': '/customers',
  '/company-registration': '/companies',
  '/company-edit': '/companies',
  '/webchat-registration': '/webchats',
  '/webchat-edit': '/webchats',
  '/chatbot-registration': '/chatbots',
  '/chatbot-edit': '/chatbots',
  '/chatclassifications-edit': '/chatclassifications',
  '/quick-responses-registration': '/quick-responses',
  '/quick-responses-edit': '/quick-responses',
  '/template-message-registration': '/template-message',
  '/template-message-edit': '/template-message',
  '/phoneregistrationrequests-registration': '/phoneregistrationrequests',
  '/phoneregistrationrequests-edit': '/phoneregistrationrequests',
  '/rulesattendance-registration': '/rulesattendance',
  '/rulesattendance-edit': '/rulesattendance',

  // Pausas
  '/break-reason-registration': '/break-reasons',
  '/break-reason-edit': '/break-reasons',

  // Base de conhecimento / artigos / FAQ / portal
  '/knowledgebase-registration': '/knowledgebases',
  '/knowledgebase-edit': '/knowledgebases',
  '/articles-registration': '/articles',
  '/articles-edit': '/articles',
  '/articles-section-registration': '/articles-section',
  '/articles-section-edit': '/articles-section',
  '/faq-registration': '/faq',
  '/faq-import': '/faq',
  '/faq-edit': '/faq',
  '/faq-subject-registration': '/faq-subject',
  '/faq-subject-edit': '/faq-subject',
  '/feedback-article-registration': '/feedbackarticles',
  '/feedback-article-edit': '/feedbackarticles',
  '/portal-category': '/portal',
};
